import React from 'react';
import PoolBalanceChart from '../components/PoolBalanceChart';
import TraderListTable from '../components/trader/TraderListTable';

const Trader: React.FC = () => {
  return (
    <div className="min-h-screen p-4 sm:p-6 lg:p-8">
      <div className="max-w-7xl mx-auto">
        <h1 className="text-2xl sm:text-3xl font-bold text-black dark:text-white mb-4 sm:mb-6">Trader</h1>
        <div className="grid grid-cols-1 gap-4 sm:gap-6">
          <PoolBalanceChart />
          <TraderListTable />
        </div>
      </div>
    </div>
  );
};

export default Trader; 